export default __webpack_public_path__ + "static/media/mailz.d13d5e32.jpeg";